import {observer} from "mobx-react";
import {OrganizationPanel} from "../../OrganizationPanel";
import {ServiceTypePanel} from "../../ServiceTypePanel";
import {HolderPanel} from "../../holder/HolderPanel";
import {BankDataPanel} from "../../BankDataPanel";
import {InsurancePanel} from "../../InsurancePanel";
import {DeliveryInfoPanel} from "../../delivery/DeliveryInfoPanel";
import {DocumentPanel} from "../../document/DocumentPanel";
import {VehiclePanelUo} from "./VehiclePanelUo";
import {PreviousRegistrationPanelUo} from "./PreviousRegistrationPanelUo";
import {AffiliatePanel} from "../../AffiliatePanel";

const DetailUo = observer(function DetailUo() {
    return <div className="columns">
        <div className="column is-half">
            <div className="columns">
                <div className="column is-half">
                    <ServiceTypePanel/>
                </div>
                <div className="column is-half">
                    <OrganizationPanel/>
                </div>
            </div>
            <HolderPanel />
            <BankDataPanel />
            <div className="columns">
                <div className="column is-half">
                    <InsurancePanel />
                </div>
                <div className="column is-half">
                    <AffiliatePanel />
                </div>
            </div>
        </div>
        <div className="column is-half">
            <VehiclePanelUo />
            <PreviousRegistrationPanelUo />
            <DeliveryInfoPanel />
            <DocumentPanel />
        </div>
    </div>
})

export {
    DetailUo
}
